/**
 * Unsupported-locale redirect to the shared CIAM error page.
 *
 * `error_detail` includes both `lang` and `ui_locales`. Some `/authorize`
 * callers (notably KLS invitation redirects) send `lang` alongside
 * `ui_locales`.
 */
import { getLocaleEnv } from "@/utils/locale/env";

const DEFAULT_ERROR_PAGE_URL = "https://errors.ciam.fielmann.com";

export function getUnsupportedLocaleErrorPageUrl(): string {
  const envUrl = getLocaleEnv().errorPageUrl;

  if (typeof envUrl === "string" && envUrl.length > 0) {
    return envUrl;
  }

  return DEFAULT_ERROR_PAGE_URL;
}

export interface RedirectUnsupportedLocaleInput {
  /** Raw `authorization_params.ui_locales` (first token is authoritative). */
  uiLocales: string | null;
  /** Optional `authorization_params.lang`. */
  lang?: string | null;
}

/** Redirects when no supported locale can be derived. */
export function redirectUnsupportedLocale(
  input: RedirectUnsupportedLocaleInput,
): void {
  const requestedLocale = input.uiLocales ?? input.lang ?? null;
  const errorDescription = `Requested locale: ${
    requestedLocale ?? "null"
  } is not supported`;
  const truncatedUi = (input.uiLocales ?? "").substring(0, 5);
  const truncatedLang = (input.lang ?? "").substring(0, 5);
  const errorDetail = JSON.stringify({
    lang: truncatedLang,
    ui_locales: truncatedUi,
  });
  const errorDetailEncoded = btoa(errorDetail);

  const errorPageUrl = getUnsupportedLocaleErrorPageUrl();
  const redirectUrl = `${errorPageUrl}/?error=unsupported_locale&error_description=${encodeURIComponent(
    errorDescription,
  )}&error_detail=${encodeURIComponent(errorDetailEncoded)}`;

  window.location.assign(redirectUrl);
}
